module.exports = __webpack_public_path__ + "img/Vida Nocturna.d64b0ed4.png";